import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: ReactNode;
}
const FeaturePoint = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-16943" data-mp="3d0nnqevc2lp4">
      <div className="flex-shrink-0 mt-1" data-id="element-16944" data-mp="38vxvczzvvp8y">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-16945" data-mp="38ytqyho9e1u8" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-16946" data-mp="33yo4dfwuj5j0">{children}</div>
    </div>;
};
export default FeaturePoint;